import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    try {
      const u = localStorage.getItem("pc_user");
      if (u) setUser(JSON.parse(u));
    } catch (err) {
      console.warn("Failed to parse stored user", err);
    }
  }, []);
  const login = (u) => { setUser(u); localStorage.setItem("pc_user", JSON.stringify(u)); };
  const logout = async () => {
    try {
      // Best-effort server-side session invalidation; ignore errors
      await axios.post("/api/auth/logout");
    } catch (err) { /* ignore */ }
    setUser(null);
    localStorage.removeItem("pc_user");
  };
  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
